import { SelectHTMLAttributes } from "react";
import classes from './Select.module.css'

const Select = (props: SelectHTMLAttributes<HTMLSelectElement>) => {
    return ( 
        <select {...props} className={classes.select}>
            {props.children}
        </select>
     );
}
 
export default Select;